import React, { useState, useEffect } from "react";
import thumbnail from "../assets/Thumbnail.png";
import Navbar from "./Navbar";
import client1 from "../assets/client1.png";
import client2 from "../assets/client2.png";
import client3 from "../assets/client3.png";

// Type for a single review
type Review = {
  id: number;
  name: string;
  role: string;
  message: string;
  image: string;
};

// Static reviews array with types
const reviews: Review[] = [
  {
    id: 1,
    name: "Alice Brown",
    role: "CTO, Tech Innovators Inc.",
    message:
      "Apexium's solutions transformed our infrastructure. Their expertise is unparalleled.",
    image: client1,
  },
  {
    id: 2,
    name: "Michael Lee",
    role: "Lead Developer, WebWorks",
    message:
      "The team at Apexium provided top-notch service, delivering our project on time and beyond expectations.",
    image: client2,
  },
  {
    id: 3,
    name: "Sarah Johnson",
    role: "Product Manager, CloudSync",
    message:
      "Working with Apexium has been a game-changer for our product development process.",
    image: client3,
  },
];

const Home: React.FC = () => {
  const [currentReviewIndex, setCurrentReviewIndex] = useState<number>(0);
  const [videoLoaded, setVideoLoaded] = useState<boolean>(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentReviewIndex((prevIndex) => (prevIndex + 1) % reviews.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const currentReview = reviews[currentReviewIndex];

  return (
    <>
      <div className="relative w-full h-[72vh] overflow-hidden">
        <Navbar />
        <img
          src={thumbnail}
          alt="Loading..."
          className={`absolute top-0 left-0 w-full h-[72vh] object-cover transition-opacity duration-500 ${videoLoaded ? 'opacity-0' : 'opacity-100'}`}
        />
        <video
          autoPlay
          loop
          muted
          playsInline
          className={`absolute top-0 left-0 w-full h-[72vh] object-cover transition-opacity duration-500 ${videoLoaded ? 'opacity-100' : 'opacity-0'}`}
          onLoadedData={() => setVideoLoaded(true)}
          onError={(e: React.SyntheticEvent<HTMLVideoElement, Event>) => {
            console.error("Error loading video:", e);
          }}
        >
          <source src="https://apexium.s3.ap-south-1.amazonaws.com/static/videos/Home-Video.mp4" type="video/mp4" />
        </video>
        <div className="relative z-10 flex items-center justify-center h-full text-white px-8 lg:px-16">
          <div>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 text-center">
              Welcome to Apexium Technology
            </h1>
            <p className="text-lg md:text-xl lg:text-2xl text-right">
              Empowering Tech Solutions
            </p>
          </div>
        </div>
      </div>

      <div
        style={{ backgroundColor: "#070F2B", color: "#f0f0f0" }}
        className="relative z-10 p-8 md:p-12 lg:p-16"
      >
        <div className="container mx-auto">
          <div className="mb-16">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-4 text-left">
              Overview
            </h2>
            <p className="text-base md:text-lg lg:text-xl mb-10 text-justify">
              Welcome to Apexium, where innovation meets excellence. As a
              product-based IT company, we are dedicated to delivering
              top-quality solutions that enhance your everyday life. Founded on
              April 19th, 2024, our commitment to craftsmanship, cutting-edge
              technology, and customer satisfaction drives us to create products
              that not only meet but exceed your expectations. Step into a world
              of unparalleled quality, reliability, and unmatched service with
              Apexium.
            </p>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-4 text-center">
            People Reactions
          </h2>

          <div className="flex flex-col md:flex-row justify-center items-center mt-10">
            <div
              style={{ backgroundColor: "#1B1A55", color: "#f0f0f0" }}
              className="shadow-lg rounded-lg p-6 flex flex-col md:flex-row items-center w-full max-w-3xl"
            >
              <div className="mb-4 md:mb-0 md:mr-6 flex-shrink-0">
                <img
                  src={currentReview.image}
                  alt={currentReview.name}
                  className="w-28 h-28 rounded-full object-cover"
                />
              </div>
              <div className="flex-1 text-center md:text-left">
                <p className="text-base md:text-lg lg:text-xl italic mb-4">
                  "{currentReview.message}"
                </p>
                <div>
                  <h3 className="text-base md:text-lg lg:text-xl font-semibold text-right">
                    {currentReview.name}
                  </h3>
                  <p className="text-sm md:text-base text-gray-400 text-right">
                    {currentReview.role}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer
        style={{ backgroundColor: "#070F2B" }}
        className="py-6 text-center border-t border-gray-800"
      >
        <p className="text-gray-500">
          © {new Date().getFullYear()} Apexium Technologies - All Rights
          Reserved.
        </p>
      </footer>
    </>
  );
};

export default Home;
